import { useState } from "react";
import { signInWithGoogle } from "../api/auth";
import MurooMark from "../components/MurooMark";
import "./LoginScreen.css";

/**
 * @param {object} book 검색으로 책 페이지를 거쳐 들어온 경우 그 책. 없으면 null.
 *   muroo.kr/book/<isbn> 에서 넘어온 사람은 『데미안』을 찾다 온 것이지
 *   '독서 기록 앱' 을 찾다 온 것이 아니다. 그 책을 화면에 그대로 둔다.
 */
const LoginScreen = ({ onGuest, book = null }) => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Supabase 는 팝업이 아니라 리다이렉트 방식이다.
  // 성공하면 이 페이지를 떠나므로 setLoading(false) 로 돌아올 일이 없다.
  const handleGoogle = async () => {
    setError("");
    setLoading(true);
    try {
      await signInWithGoogle();
    } catch (e) {
      setError("Google 로그인에 실패했어요.");
      setLoading(false);
    }
  };

  const handleGuest = () => {
    if (onGuest) onGuest();
  };

  return (
    <div className="login-wrap bp-layer">
      <div className="login-logo">
        <MurooMark size={104} />
        <h1>MUROO</h1>
        <p>your reading universe</p>
        {/* 가입 전에 이 앱이 무엇을 하는 곳인지 알려준다.
            영문 태그라인만으로는 처음 온 사람이 짐작할 수 없다. */}
        <p className="login-desc">읽은 책이 쌓여 나만의 행성이 됩니다</p>
      </div>

      {/* 찾아온 책이 있으면 그것부터 보여준다. 없으면 이 칸 자체가 없다. */}
      {book && (
        <div className="login-book">
          {book.cover && <img className="login-book-cover" src={book.cover} alt="" />}
          <div className="login-book-text">
            <div className="login-book-title">『{book.title}』</div>
            {book.author && <div className="login-book-author">{book.author}</div>}
            <div className="login-book-line">이 책을 읽으셨다면, 기록을 남겨보세요</div>
          </div>
        </div>
      )}
      <div className="login-form">
        {error && <div className="login-error">{error}</div>}
        <button className="btn-google" onClick={handleGoogle} disabled={loading}>
          <svg width="18" height="18" viewBox="0 0 48 48" style={{marginRight:8,verticalAlign:"middle"}}><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59a14.5 14.5 0 0 1 0-9.18l-7.98-6.19a24.03 24.03 0 0 0 0 21.56l7.98-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
          Google로 계속하기
        </button>
        <button className="btn-ghost btn-guest-small" onClick={handleGuest} disabled={loading}>
          게스트로 탐험하기
        </button>
        {/* 가입하지 않아도 무엇이 쌓여 있는지는 볼 수 있게 둔다.
            버튼처럼 보이지만 앱 밖의 페이지라 <a> 여야 하고, 새 창으로 연다 —
            여기서 나가버리면 가입하러 돌아올 길이 없다. */}
        <a
          className="btn-ghost btn-guest-small login-booklist"
          href="https://muroo.kr/booklist"
          target="_blank"
          rel="noopener noreferrer"
        >
          MUROO에 등록된 책 둘러보기
        </a>
      </div>

      {/* 아직 가입할 마음이 아닌 사람에게 남는 연결고리. 검색으로 흘러들어온
          사람이 이 화면에서 그냥 나가면 다시 만날 길이 없다. */}
      <a
        className="login-ig"
        href="https://www.instagram.com/09muroo/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="MUROO 인스타그램 (@09muroo) 새 창에서 열기"
      >
        <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
          <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" fill="none" stroke="currentColor" strokeWidth="1.7" />
          <circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
          <circle cx="17.4" cy="6.6" r="1.2" fill="currentColor" />
        </svg>
        09muroo
      </a>
    </div>
  );
};

export default LoginScreen;
